import request from './request';

export function getLiveLevelList() {
  return request.get('/api/live_level/levelList');
}
export function getMyLiveLevel() {
  return request.get('/api/live_level/myLevel');
}
export function getExpInfo() {
  return request.get('/api/live_level/expInfo');
}
